// :cow: Cosmose CONFIDENTIAL :iso:
export const regex = {
  numbers: /^\d+$/,
  realNumbers: /^[+-]?(?:\d+\.?\d*|\d*\.\d+)$/,
  password: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{8,}$/
};
